var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19198 7.59327C4.41662 7.33119 4.81118 7.30084 5.07326 7.52548L10.4998 12.1768L15.9264 7.52548C16.1885 7.30084 16.5831 7.33119 16.8077 7.59327C17.0324 7.85535 17.002 8.24991 16.7399 8.47455L10.9066 13.4745C10.6725 13.6752 10.3272 13.6752 10.0931 13.4745L4.25977 8.47455C3.99769 8.24991 3.96734 7.85535 4.19198 7.59327Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltArrowDown);
export default __webpack_public_path__ + "static/media/AltArrowDown.dad7690364585c4160dc6edd7b8fe8c2.svg";
export { ForwardRef as ReactComponent };